let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9qzYS")).then(() => parcelRequire('hePYz'));